import React, { useEffect, useState } from 'react';
import { Typography, List, ListItem } from '@mui/material';

const AssessmentPreview = ({ assessment }) => {
    const [interpretations, setInterpretations] = useState([]);
    const [recommendations, setRecommendations] = useState([]);

    useEffect(() => {
        if (assessment) {
            setInterpretations(assessment.interpretations || []);
            setRecommendations(assessment.recommendations || []);
        }
    }, [assessment]);

    if (!assessment) {
        return <Typography>No assessment data available</Typography>;
    }

    const { questions = [], instructions, assignment_type } = assessment;

    return (
        <div style={{ padding: '16px' }}>
            <Typography variant="h6" gutterBottom style={{ color: "#0a0068", fontWeight: 900 }}>
                {assessment.assignment_name}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                Assessment Name: <b>{assignment_type}</b> | Client: <b>{assessment.program_code}</b>
            </Typography>

            <Typography gutterBottom style={{ color: "#0a0068", fontSize: "16px", marginTop: '16px', fontWeight: 900 }}>
                Instructions:
            </Typography>
            <div
                style={{ fontSize: "14px", marginBottom: '16px' }}
                dangerouslySetInnerHTML={{ __html: instructions || "No instructions provided" }}
            />

            <Typography gutterBottom style={{ color: "#0a0068", fontSize: "16px", fontWeight: 900 }}>
                Questions:
            </Typography>

            {questions.length > 0 ? (
                questions.map((question, index) => (
                    <div key={`question-${index}`} style={{ marginBottom: "16px" }}>
                        <Typography style={{ fontSize: "14px", fontWeight: 700 }}>
                            {`${index + 1}. ${question.question}`}
                        </Typography>
                        <List dense>
                            {(question.options || []).map((option, optionIndex) => (
                                <ListItem key={`option-${optionIndex}`} style={{ padding: "4px 16px" }}>
                                    <Typography style={{ fontSize: "14px" }}>
                                        {`${String.fromCharCode(97 + optionIndex)}) ${option}`}
                                    </Typography>
                                </ListItem>
                            ))}
                        </List>
                    </div>
                ))
            ) : (
                <Typography style={{ fontSize: "14px" }}>No questions available</Typography>
            )}

            <hr style={{ margin: "16px 0" }} />

            <Typography style={{ fontSize: "14px", fontWeight: 700, marginBottom: "5px", color: "#0a0068", fontWeight: 900 }}>
                Interpretations
            </Typography>

            {interpretations.length > 0 ? (
                interpretations.map((interpretation, index) => (
                    <div key={`interpretation-${index}`} style={{ marginBottom: "16px" }}>
                        <Typography style={{ fontSize: "14px", fontWeight: 700, margin: "5px 0" }}>
                            {`${interpretation.minScore} to ${interpretation.maxScore} (${interpretation.name}):`}
                        </Typography>
                        <div
                            style={{ fontSize: "14px" }}
                            dangerouslySetInnerHTML={{ __html: interpretation.description || "No description available" }}
                        />
                    </div>
                ))
            ) : (
                <Typography style={{ fontSize: "14px" }}>No interpretations available</Typography>
            )}

            <hr style={{ margin: "16px 0" }} />

            <Typography style={{ fontSize: "14px", fontWeight: 700, color: "#0a0068" }}>
                Recommendations
            </Typography>

            {recommendations.length > 0 ? (
                recommendations.map((recommendation, index) => (
                    <div key={`recommendation-${index}`} style={{ marginBottom: "16px" }}>
                        {recommendation.name && (
                            <Typography style={{ fontSize: "14px", fontWeight: 700, margin: "5px 0" }}>
                                {recommendation.name}:
                            </Typography>
                        )}
                        <div
                            style={{ fontSize: "14px" }}
                            dangerouslySetInnerHTML={{ __html: recommendation.description || "No recommendation available" }}
                        />
                    </div>
                ))
            ) : (
                <Typography style={{ fontSize: "14px" }}>No recommendations available</Typography>
            )}

            <div style={{ marginTop: '16px', color: '#666', fontSize: '12px' }}>
                <Typography>Created by: {assessment.created_by}</Typography>
                <Typography>Created at: {assessment.created_at}</Typography>
                {assessment.updated_at && <Typography>Last updated: {assessment.updated_at}</Typography>}
            </div>
        </div>
    );
};

export default AssessmentPreview;